import { v4 as uuid } from "uuid";
import { EmployeeLineItem, EmploymentType, Gender } from "./employee";

import * as EntityLabourHour from "../entities/labourHour";
import { getEmployeeFactors } from "decoders/employee";
import { ContractorPackageLineItem } from "./contractorPackage";

export type LabourHour = EntityLabourHour.LabourHour;

export type LabourHourLineItem = {
  id: string;
  reportId: string;
  amount: number;
  employeeId: string;
  employeeName: string;
  gender: Gender;
  employmentType: string;
  socialFactors: string[];
  created: Date;
};

export interface LabourHourTableRow {
  id: string;
  reportId: string;
  amount: number;
  employeeId: string;
  employeeName: string;
  gender: Gender;
  employmentType: EmploymentType;
  empty?: boolean;
  dirty?: boolean;
  invalid?: boolean;
  socialFactors: Record<string, boolean>;
}

export const createDefaultLabourHour = (
  reportId: string,
  contractorPackage: ContractorPackageLineItem,
  employee?: EmployeeLineItem
): LabourHourLineItem => {
  const socialFactors = employee
    ? getEmployeeFactors(contractorPackage, employee)
    : [];
  return {
    id: uuid(),
    reportId,
    employeeId: employee?.id || "",
    employeeName: employee?.employeeName || "",
    gender: employee?.gender || Gender.Male,
    employmentType: employee?.employmentType || "",
    socialFactors,
    amount: 0,
    created: new Date(),
  };
};
